<div class="container">

  <div class="label-container" style="text-align: center;">
    <div class="titulo-contact">{{tittle}}</div>
  </div>

  <div class="contact-container animate__animated animate__fadeIn">
    <div class="contact-row">
      <div class="videollamada">
        <span (click)="agendar()" class="videollamada-icons"><span class="material-symbols-outlined">videocam</span>Videollamada</span>
      </div>
      <div class="llamar-container">
        <div class="llamar">
          @if (!loading_name && !sinContacto) {
          <a class="animate__animated animate__fadeIn llamar-icons"
            [href]="'https://wa.me/' + getCleanNumber(contacto)"
            target="_blank"
            rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <span class="material-symbols-outlined">forum</span> +{{contacto}}
          </a>
          }

          @if (sinContacto) {
            <div class="llamar-icons-sin">
              <span class="material-symbols-outlined">support_agent</span>{{ contacto }}
            </div>
          }
        </div>
        <div class="ejecutivo-container">
          @if (!loading_name) {
            <span class="ejecutivo-info">Ejecutivo: {{name}}</span>
          }
        </div>
      </div>
    </div>
  </div>

</div>